import {Component} from "@angular/core";
import {MachineManagerService} from "../../../../services/machine-manager.service";
import {SessionManagerService} from "../../../../services/session-manager.service";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {Level, Message} from "../../../../model/message.component";
import {ProcessReport} from "../../../../model/reports.model";

@Component({
  selector: "machine-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.css"]
})
export class SettingsComponent {

  nextBatch: String = ""

  constructor(
    private machineManager: MachineManagerService,
    private viewManager: ViewManagerService,
    private sessionManager: SessionManagerService
  ) {
  }

  getMachine() {
    return this.machineManager.machine;
  }

  set() {
    let owner = this.sessionManager?.session?.space ?? "";
    if (this.nextBatch != "") {
      this.viewManager.displayMessage(new Message("Machine execution is set for batch: " + this.nextBatch, new Level("info")))
      this.machineManager.set(owner, this.nextBatch);
      this.nextBatch = "";
    } else {
      this.viewManager.displayMessage(new Message("Next batch will calculated", new Level("warning")));
      this.machineManager.set(owner, "");
    }
  }

  reload() {
    let owner = this.sessionManager?.session?.space ?? "";
    this.machineManager.reload(owner)
  }

  statusClass(status: string) {
    if (status == "SUCCESS") {
      return "success";
    } else if (status == "RUNNING") {
      return "running";
    } else if (status == "ERRORS") {
      return "errors";
    } else if (status == "DONE") {
      return "done";
    }
    return "disabled";
  }
}
